/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./myscript.js');

window.Vue = require('vue');

import BootstrapVue from 'bootstrap-vue'
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin

import { createPopper } from '@popperjs/core';
const popcorn = document.querySelector('#popcorn');
const tooltip = document.querySelector('#tooltip');
// createPopper(popcorn, tooltip, {
//   placement: 'top',
// });

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('navbar-component', require('./components/NavbarComponent.vue').default);
Vue.component('select-component', require('./components/SelectSearch.vue').default);
Vue.component('block-component', require('./components/BlockComponent.vue').default);
Vue.component('feature-viewer-component', require('./components/FeatureViewerComponent.vue').default);
Vue.component('hmm-component', require('./components/HMMLogoComponent.vue').default);
Vue.component('table-component', require('./components/TableComponent.vue').default);
Vue.component('alignment-viewer-component', require('./components/AlignmentViewerComponent.vue').default);
Vue.component('details-table', require('./components/DetailsTable.vue').default);
Vue.component('general-doc', require('./components/GeneralDoc.vue').default);

Vue.component('mutation-table-component', require('./components/MutationTableComponent.vue').default);
Vue.component('alignment-viewer-component-test', require('./components/AlignmentViewerComponentTest.vue').default);

// Contact us (user can be authenticated or not)
Vue.component('contact-us', require('./components/ContactUs.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */



const app = new Vue({
    el: '#app',
});

